import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Reservation } from 'src/app/models/Reservation';
import { ReservationType } from 'src/app/models/ReservationType';
import { common_environment } from 'src/environments/common.environment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-booking-details-modal',
  templateUrl: './booking-details-modal.component.html',
  styleUrls: ['./booking-details-modal.component.scss']
})
export class BookingDetailsModalComponent {
  @Input() modelId: any;
  @Input() modalName: string;
  @Input() title: string;
  @Input() modalType: string;
  @Input() routeName: string;
  @Input() clickedBrandId: string;
  @Input() singleBooking: Reservation;
  @Input() bookedDuration: any;
  public currency = `${environment.currency}`;
  submitted: any = false
  brand: any = false
  isSuccess: any = false
  loading: any = false
  formMessage: any = ''

  constructor() {
  }

  ngOnInit(): void {

  }


  zoneSeatForm: FormGroup = new FormGroup({

  })

  onAddClick() {
  }

  onEditClick() {
  }
}
